import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '@/componentsDS/Modal/Modal';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Button from '@/components/Button';
import { ReactComponent as ActivityLogIcon } from '@/assets/svgs/icon-activity-log-etr.svg';

const DefaultEntry = ({ entry }) => (
    <div className="DS__activity-log-modal__entry">
        {entry.icon && <div className="DS__activity-log-modal__entry-icon">{entry.icon}</div>}
        <div className="DS__activity-log-modal__entry-body">
            {entry.heading && (
                <div className="DS__activity-log-modal__entry-heading">{entry.heading}</div>
            )}
            {Array.isArray(entry.details) && entry.details.length > 0 && (
                <ul className="DS__activity-log-modal__entry-details">
                    {entry.details.map((d, i) => (
                        <li key={d.label ? `${d.label}-${i}` : i}>
                            {d.label && (
                                <span className="DS__activity-log-modal__entry-details-label">
                                    {d.label}:{' '}
                                </span>
                            )}
                            <span className="DS__activity-log-modal__entry-details-value">
                                {d.value}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
            {entry.body && <div className="DS__activity-log-modal__entry-content">{entry.body}</div>}
            {entry.meta && <div className="DS__activity-log-modal__entry-meta">{entry.meta}</div>}
        </div>
    </div>
);

DefaultEntry.propTypes = {
    entry: PropTypes.object.isRequired,
};

const ActivityLogModal = ({
    visible,
    close,
    entries = [],
    title = 'Activity Log',
    icon,
    renderEntry,
    emptyState = 'No activity to show',
    closeLabel = 'Close',
    className,
    dataTestId = 'activity-log-modal',
}) => {
    const renderEntries = () =>
        entries.map((entry, idx) => (
            <div
                className="DS__activity-log-modal__entry-wrap"
                key={entry.id ?? entry.key ?? idx}
            >
                {renderEntry ? renderEntry(entry, idx) : <DefaultEntry entry={entry} />}
            </div>
        ));

    return (
        <Modal visible={visible} variant="medium" close={close} data-testid={dataTestId}>
            <CardConfigure>
                <CardConfigure.Header>
                    <CardConfigure.Header.Title>
                        <div className="card-configure__header__left">
                            <div className="card-configure__title">
                                <div className="card-configure__title__left">
                                    <span className="DS__activity-log-modal__title-icon">
                                        {icon || <ActivityLogIcon />}
                                    </span>
                                </div>
                                <div className="card-configure__title__right">
                                    <div className="card-configure__title__right__top">{title}</div>
                                </div>
                            </div>
                        </div>
                    </CardConfigure.Header.Title>
                </CardConfigure.Header>
                <CardConfigure.Body>
                    <CardConfigure.Body.Col>
                        <div className={classNames('DS__activity-log-modal__body', className)}>
                            {entries.length > 0 ? (
                                renderEntries()
                            ) : (
                                <div className="DS__activity-log-modal__empty">{emptyState}</div>
                            )}
                        </div>
                    </CardConfigure.Body.Col>
                </CardConfigure.Body>
                <CardConfigure.Footer>
                    <CardConfigure.Footer.Right>
                        <Button text={closeLabel} round full submit={close} />
                    </CardConfigure.Footer.Right>
                </CardConfigure.Footer>
            </CardConfigure>
        </Modal>
    );
};

ActivityLogModal.propTypes = {
    visible: PropTypes.bool,
    close: PropTypes.func,
    entries: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            icon: PropTypes.node,
            heading: PropTypes.node,
            body: PropTypes.node,
            details: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.node,
                    value: PropTypes.node,
                })
            ),
            meta: PropTypes.node,
        })
    ),
    title: PropTypes.node,
    icon: PropTypes.node,
    renderEntry: PropTypes.func,
    emptyState: PropTypes.node,
    closeLabel: PropTypes.string,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
};

export default ActivityLogModal;
